import { Col, Input, Row } from "reactstrap"
import styles from "./NewLoanApplication.module.scss"
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton"
import Checkbox from "../../../../../components/common/Checkbox/Checkbox"
import SecondaryButton from "../../../../../components/common/SecondaryButton/SecondaryButton"

const NewLoanApplication = () => {
  return (
    <section>
      <div className="fw-semibold fs-5 my-3">New Loan Application</div>

      <div className={styles["heading"]}>Personal Information</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Full Name:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter name of the product" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Address:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Choose from dropdown menu" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Phone Number:</Col>
            <Col xs='12' lg="4">
              <Input type="number" placeholder="Enter phone" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Email Address:</Col>
            <Col xs='12' lg="4">
              <Input type="text" placeholder="Enter email" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Date of Birth:</Col>
            <Col xs='12' lg="4">
              <Input type="date" />
            </Col>
          </Row>
        </div>
      </div>

      <div className={styles["heading"]}>Business Information</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Business Name:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter business name" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Business Type:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter business type" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Business Address:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter business address" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Business Phone Number:</Col>
            <Col xs='12' lg="4">
              <Input type="number" placeholder="Enter phone" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Tax Identification Number (TIN):</Col>
            <Col xs='12' lg="4">
              <Input type="text" placeholder="Enter TIN" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Years in Business:</Col>
            <Col xs='12' lg="4">
              <Input type="text" placeholder="Enter Years" />
            </Col>
          </Row>
        </div>
      </div>

      <div className={styles["heading"]}>Loan Amount</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Select Loan Type:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter loan type" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Business Type:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter business type" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Enter Loan Amount:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter amount" type="number" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Enter Loan Term (Months):</Col>
            <Col xs='12' lg="4">
              <Input type="number" placeholder="Enter Months" />
            </Col>
          </Row>
          <Row className="g-0">
            <Col xs='12' lg="2">Purpose of Loan:</Col>
            <Col xs='12' lg="4">
              <Input type="textarea" />
            </Col>
          </Row>
        </div>
      </div>

      <div className={styles["heading"]}>Financial Information</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Annual Revenue:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter loan type" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Net Profit:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter business type" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Monthly Operating Expenses:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter amount" type="number" />
            </Col>
          </Row>
        </div>
      </div>

      <div className={styles["heading"]}>Agreement</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Loan Agreement:</Col>
            <Col xs='12' lg="4">
              <SecondaryButton name={"View Loan Agreement Terms & Conditions"} />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Agree to terms:</Col>
            <Col xs='12' lg="4">
              <div className="d-flex align-items-center gap-2">
                <span>Check mark </span>
                <Checkbox />
              </div>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs="2">Electronic Signature:</Col>
            <Col xs="4">
              <Input placeholder="Enter amount" type="number" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Enter Loan Term (Months):</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter amount" type="number" />
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Date:</Col>
            <Col xs='12' lg="4">
              <Input placeholder="Enter amount" type="date" />
            </Col>
          </Row>
        </div>
      </div>

      <div className={styles["heading"]}>Documents Upload</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Business Registration Certificate:</Col>
            <Col xs='12' lg="4">
              <SecondaryButton name={"Upload document"} /> <span>Uploaded document name</span>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Tax Returns:</Col>
            <Col xs='12' lg="4">
              <SecondaryButton name={"Upload document"} /> <span>Uploaded document name</span>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Financial Statements:</Col>
            <Col xs='12' lg="4">
              <SecondaryButton name={"Upload document"} /> <span>Uploaded document name</span>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Proof of Identity:</Col>
            <Col xs='12' lg="4">
              <SecondaryButton name={"Upload document"} /> <span>Uploaded document name</span>
            </Col>
          </Row>
          <Row className="g-0 align-items-center">
            <Col xs='12' lg="2">Other Supporting Documents:</Col>
            <Col xs='12' lg="4">
              <SecondaryButton name={"Upload document"} /> <span>Uploaded document name</span>
            </Col>
          </Row>
        </div>
      </div>


      <div className="d-flex justify-content-center my-3">
        <PrimaryButton name={"Submit Application"} />
      </div>
    </section>
  )
}

export default NewLoanApplication
